import { render, staticRenderFns } from "./AirportProducts.vue?vue&type=template&id=84797f40&"
import script from "./AirportProducts.vue?vue&type=script&lang=js&"
export * from "./AirportProducts.vue?vue&type=script&lang=js&"
import style0 from "./AirportProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports